import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VueScrollTo from 'vue-scrollto';
import Vuebar from 'vuebar';
import Datetime from 'vue-datetime';
import 'froala-editor/js/plugins.pkgd.min';
import VueFroala from 'vue-froala-wysiwyg';
import VueMasonry from 'vue-masonry-css'
import Affix from 'vue-affix';
import PortalVue from 'portal-vue';
import { Wormhole } from 'portal-vue';
import VuexORM, { Database } from '@vuex-orm/core';
import VuexORMAxios from 'huddlebv-plugin-axios';
import forEach from 'lodash.foreach';
import Croppa from 'vue-croppa';
import VTooltip from 'v-tooltip';
import ActiveData from './ActiveData-v0.1';
import Moment from 'moment';
import VueMeta from 'vue-meta';
import FunctionalCalendar from 'vue-functional-calendar';
import UserPlugin from './plugins/user';

/* Modules */
import cookiepopup from './modules/cookiepopup';
import quiz from './modules/quiz';
import poll from './modules/poll';
import modal from './modules/modal';

/* Models */
import Group from './models/Group';
import GroupData from './models/GroupData';
import Notification from './models/Notification';
import Level from './models/Level';
import LevelData from './models/LevelData';
import Event from './models/Event';
import EventData from './models/EventData';
import Trophy from './models/Trophy';
import EventCategory from './models/EventCategory';
import Reminder from './models/Reminder';
import Message from './models/Message';
import Thread from './models/Thread';
import Participant from './models/Participant';
import HuddleUser from './models/HuddleUser';
import CourseV2 from './models/Course';
import CourseV4 from './models/CourseV4';
import CourseCatalogV4 from './models/CourseCatalogV4';
import LessonV4 from './models/LessonV4';
import LiveRoom from './models/LiveRoom';
import LiveRoomParticipant from './models/LiveRoomParticipant';
import Channel from './models/Channel';
import ChannelData from './models/ChannelData';

Vue.use(Vuex);
Vue.use(VueScrollTo);
Vue.use(Vuebar);
Vue.use(Datetime);
Vue.use(VueMasonry);
Vue.use(VueFroala);
Vue.use(Affix);
Vue.use(PortalVue);
Vue.use(Croppa, { componentName: 'image-cropper' });
Vue.use(VTooltip, {
    defaultDelay: { show: 0, hide: 0 },
    defaultOffset: 5,
    defaultClass: 'tooltip',
    defaultTrigger: 'hover focus click',
    defaultBoundariesElement: 'window',
});
Vue.use(VueMeta);
Vue.use(FunctionalCalendar, {
    dayNames: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
});
Vue.use(UserPlugin);

Wormhole.trackInstances = false;

VuexORM.use(VuexORMAxios, { axios });

const database = new VuexORM.Database();

database.register(Group, GroupData);
database.register(Notification);
database.register(Level, LevelData);
database.register(Event, EventData);
database.register(Trophy);
database.register(EventCategory);
database.register(Reminder);
database.register(Message);
database.register(Thread);
database.register(Participant);
database.register(HuddleUser);
database.register(CourseV2);
database.register(CourseV4);
database.register(CourseCatalogV4);
database.register(LessonV4);
database.register(LiveRoom);
database.register(LiveRoomParticipant);
database.register(Channel, ChannelData);

const state = {
    //ajax spinner
    showSpinner: false,
    //new theme popup
    showNewThemePopup: false,
    //full screen search
    full_screen_search_open: false,
    //new user check
    checkedForNewUser: true,
    isNewUser: false,
    settings: false,
    translations: [],
    plugins: '',
    //feed switch vars
    feedSwitch: false,
    displayMode: 'big',
    //new post vars
    boards: [],
    moodboards: [],
    subboards: [],
    activeBoard: '',
    activeSubboard: '',
    boards_loaded: false,
    moodboards_loaded: false,
    postType: 'text',
    videoUrl: '',
    postTitle: '',
    postContent: '',
    pollQuestion: '',
    postImagesCount: 0,
    postImages: [],
    postImagesUUIDs: [],
    postImagesPreview: [],
    postSticky: false,
    postAttachments: [],
    postAttachmentsUUIDs: [],
    postDate: '',
    pollImagesCount: 0,
    pollImages: [],
    pollImagesUUIDs: [],
    pollImagesPreview: [],
    initImagePicker: false,
    //feed vars
    topics: [],
    topics_ids: [],
    comments: [],
    replies: [],
    users: [],
    likes: [],
    loggedIn: false,
    user: false,
    helpdeskFilter: 'all',
    //moodview vars
    moodviewOpen: false,
    moodboardTopic: false,
    //emoji editor vars
    huddleEditors: [],
    activeHuddleEditor: null,
    fireTab: false,
    focusOnEditor: null,
    // huddle editor v2 vars
    active_editor_v2_uuid: false,
    // Blog posts in sidebar
    blogPost: [],
    emptyBlogImage: 'img/blogpost_empty.jpg',
    //trophies
    activeTrophy: [],
    trophies: [],
    trophiesProgress: 0,
    //activedata
    route_active_data_models: {},
    loaded_active_data_sets: [],
    require_active_data_models_called: false,
    required_active_data_models: [],
    required_active_data_model_are_loaded: false,
    comment_load_timeout: 0,
    reply_load_timeout: 0,
    appear_logged_in: {
        status: false,
        name: '',
        avatar: '',
    },
    search_results: {
        conversations: [],
        users: [],
        courses: [],
        lessons: [],
        boards: [],
    },
    errorMessage: '',
    showBottomError: false,
    courses: [],
    courses_ids: [],
    modules: [],
    modules_ids: [],
    lessons: [],
    lessons_ids: [],
    authors: [],
    authors_ids: [],
    display_content_without_module: true,
    content_edit_type: false,
    content_edit_quiz_id: false,
    content_edit_iframe: '',
    content_edit_video: '',
    // groups
    groups: [],
    // ui
    screen_width: 0,
    inboxCount: 0,
    privateChannel: '',
};

let getters = {
    getLikeByUsername: (state) => (id) => {
        return state.likes.findIndex(like => like.user().username === user.username && like.topic().post_id === id)
    },

    getTopicById: (state) => (id) => {
        return state.topics.filter(topic => topic.id === id);
    },

    getLessonById: (state) => (id) => {
        return state.lessons.find(lesson => lesson.id === id);
    },

    getLessonIndexById: (state) => (id) => {
        return state.lessons.findIndex(lesson => lesson.id === id)
    },

    getModuleIndexById: (state) => (id) => {
        return state.modules.findIndex(module => module.id === id)
    },
    getInboxCount: (state) => state.inboxCount,
};

let mutations = {
    setAppearLoggedIn(state, payload) {
        state.appear_logged_in.status = true;
        state.appear_logged_in.name = payload.name;
        state.appear_logged_in.avatar = payload.avatar;
    },
    toggleNewThemePopup(state) {
        state.showNewThemePopup = !state.showNewThemePopup;
    },

    toggleFullScreenSearch(state) {
        state.full_screen_search_open = !state.full_screen_search_open;
    },

    setSearchResults(state, payload) {
        //define the array of items that we might receive from the backend
        let items = ['users', 'conversations', 'courses', 'lessons', 'boards'];

        //if we are adding more results to a specific item in the store
        if (payload.search_more) {
            //loop through the items
            for (let i = 0; i < items.length; i++) {
                //see if the item has any results
                if (payload.results[items[i]] && payload.results[items[i]].data.length > 0) {
                    //loop through the results
                    for (let y = 0; y < payload.results[items[i]].data.length; y++) {
                        if (payload.results[items[i]].data[y] !== null && typeof payload.results[items[i]].data[y] !== 'undefined') {
                            //add each result to the store
                            state.search_results[items[i]].data.push(payload.results[items[i]].data[y]);
                        }
                    }
                }
            }
        } else {
            //update store with the results for each item
            for (let i = 0; i < items.length; i++) {
                if (payload.results[items[i]] && payload.results[items[i]].data.length > 0) {
                    state.search_results[items[i]] = payload.results[items[i]];

                    // filter out results that are null or undefined
                    const indexes_to_filter = [];
                    let amount_filtered = 0;

                    for (let y = 0; y < state.search_results[items[i]].data.length; y++) {
                        if (state.search_results[items[i]].data[y] === null || typeof state.search_results[items[i]].data[y] === 'undefined') {
                            indexes_to_filter.push(y);
                        }
                    }

                    for (let z = 0; z < indexes_to_filter.length; z++) {
                        state.search_results[items[i]].data.splice(indexes_to_filter[z - amount_filtered], 1);
                        amount_filtered++;
                    }
                }
            }
        }
    },

    clearSearchResults(state) {
        state.search_results = {
            conversations: [],
            users: [],
            lessons: [],
            boards: [],
            courses: [],
        };
    },

    toggleSpinner(state, payload) {
        state.showSpinner = payload;
    },

    setSettings(state, payload) {
        state.settings = payload;
    },

    setTranslations(state, payload) {
        state.translations = payload;
    },

    setPlugins(state, payload) {
        state.plugins = JSON.parse(payload);
    },

    resetFeed() {
        state.topics = [];
        state.topics_ids = [];
        state.comments = [];
        state.comments_ids = [];
        state.replies = [];
        state.replies_ids = [];
        state.users = [];
        state.users_ids = [];
        state.likes = [];
        state.likes_ids = [];
    },

    //feed switch mutations
    setFeedSwitch(state, payload) {
        state.feedSwitch = payload;
    },

    //display mode mutations
    setDisplayMode(state, payload) {
        state.displayMode = payload;
    },

    //new post mutations
    setBoards(state, payload) {
        state.boards = payload;
    },

    setMoodboards(state, payload) {
        state.moodboards = payload;
    },

    setUser(state, payload) {
        state.user = payload.data;
    },

    setActiveBoard(state, payload) {
        if (payload[1] === 'main') {
            state.activeBoard = payload[0];
            state.activeSubboard = '';
        } else if (payload[1] === 'sub') {
            state.activeSubboard = payload[0];
        } else if (payload[1] === 'group') {
            state.activeBoard = payload[0];
        }
    },

    setPostType(state, type) {
        state.postType = type;
    },

    updateNewPostTitle(state, payload) {
        state.postTitle = payload;
    },

    setInboxCount(state, payload) {
        state.inboxCount = payload;
    },

    setPrivateChannel(state, payload) {
        state.privateChannel = payload;
    },

    updateNewPostContent(state, payload) {
        state.postContent = payload;
    },

    updateNewPostVideoUrl(state, message) {
        state.videoUrl = message;
    },

    updateNewPollQuestion(state, payload) {
        state.pollQuestion = payload;
    },

    updateNewPostAttachments(state, payload) {
        for (let i = 0, file; file = payload.files[i]; i++) {
            state.postAttachments.push(file);
            state.postAttachmentsUUIDs.push(payload.uuids[i]);
        }
    },

    clearNewPost(state) {
        if (!boardId) {
            state.activeBoard = '';
        }

        state.postType = 'text';
        state.postTitle = '';
        state.postContent = '';
        state.pollQuestion = '';
        state.videoUrl = '';
        state.initImagePicker = false;
        state.postSticky = false;
        state.postAttachments = [];
        state.postAttachmentsUUIDs = [];
        state.postDate = '';
        state.postImagesCount = 0;
        state.postImages = [];
        state.postImagesUUIDs = [];
        state.postImagesPreview = [];
        state.postImageType = [];
        state.pollImages = [];
        state.pollImagesPreview = [];
        state.pollImagesUUIDs = [];
        state.pollImagesCount = 0;
    },

    addNewPollImage(state, payload) {
        state.pollImages.push(payload.file);
        state.pollImagesUUIDs.push(payload.uuid);
        state.pollImagesCount++;
    },

    addNewPollImagePreview(state, src) {
      state.pollImagesPreview.push(src);
    },

    addNewPostImage(state, payload) {
        state.postImages.push(payload.file);
        state.postImagesUUIDs.push(payload.uuid);
        state.postImagesCount++;
    },

    addNewPostImagePreview(state, src) {
        state.postImagesPreview.push(src);
    },

    removeNewPostImage(state, index) {
        state.postImages.splice(index, 1);
        state.postImagesPreview.splice(index, 1);
        state.postImagesUUIDs.splice(index, 1);
        state.postImagesCount--;
    },

    removeNewPollImage(state, index) {
        state.pollImages.splice(index, 1);
        state.pollImagesPreview.splice(index, 1);
        state.pollImagesUUIDs.splice(index, 1);
        state.pollImagesCount--;
    },

    //update post comments' counter
    postCommentsCount(state, payload) {
        if (payload[1] === 'increment') {
            payload[0].comments_count++;
        } else {
            payload[0].comments_count--;
        }
    },

    //update like count
    updatePostLike(state, payload) {
        let id = payload.id;
        let bool = payload.bool;
        let object = payload.object;
        let model = payload.model;
        model = pluralize.singular(model);

        object.liked_by_me = bool;

        if (bool === true) {
            object.likes_count++;
            object.likesCount++;

            //add the new like to active data
            let like = {
                user_id: user.id,
                username: user.username,
                name: user.first_name + ' ' + user.last_name
            };

            if (model === 'topic') {
                like.conversation_id = object.id;
            } else if (model === 'comment') {
                like.comment_id = object.id;
            } else if (model === 'reply') {
                like.reply_id = object.id;
            }

            let likes = ActiveDataStore.activeDataCreateResource(window.Like, 'likes', like);

            let like_data = {
                model: window.Like,
                instance: likes,
                plural: 'likes'
            };

            this.commit('addActiveDataInstance', like_data);

        } else {
            object.likes_count--;
            object.likesCount--;

            let indexOfLike = -1;
            let like = [];

            //remove the like frm active data
            if (model === 'topic') {
                //like = state.likes.find(like => like.user().username === state.user.username && like[model]().post_id === id);
                indexOfLike = state.likes.findIndex(like => like.username === user.username && like[model]().post_id === id);
            } else if (model === 'comment' || model === 'reply') {
                //like = state.likes.find(like => like.user().username === state.user.username && like[model]().id === id)
                indexOfLike = state.likes.findIndex(like => like.username === user.username && like[model]().id === id);
            }

            if (indexOfLike !== -1) {
                state.likes.splice(indexOfLike, 1);
            }
        }
    },

    updateTopicClosed(state, payload) {
        let topic = payload.topic;
        let bool = payload.bool;

        topic.closed = bool;
    },

    updateCommentAnswered(state, payload) {
        let topic = payload.topic;
        let comment = payload.comment;
        let bool = payload.bool;

        comment.accepted_answer = bool;
        topic.answered = bool;
    },

    updateTopicSticky(state, payload) {
        let topic = payload.topic;
        let bool = payload.bool;

        topic.sticky = bool;
    },

    updateTopicFavorite(state, payload) {
        let topic = payload.topic;
        let bool = payload.bool;

        topic.favorited = bool;
    },

    setTopicUnread(state, payload) {
        if (payload[1] === true) {
            payload[0].unread = payload[1];
        }
    },

    updateTopicNotifications(state, payload) {
        payload.topic.notifications = payload.bool;
    },

    updateTopic(state, payload) {
        payload.topic.title = payload.title;
        payload.topic.content = payload.content;
        payload.topic.excerpt = payload.content;
        payload.topic.video_url = payload.videoRegexed;
        payload.topic.board_id = payload.channel_id;
        payload.topic.slug = payload.slug;
        payload.topic.meta_title = payload.metaTitle;
        payload.topic.meta_description = payload.metaDescription;
        payload.topic.release_date = payload.release_date;

        if (payload.reload_page === true) {
            window.location.reload();
        }
    },

    newPostSticky(state) {
        state.postSticky = !state.postSticky;
    },

    newPostDate(state, date) {
        state.postDate = date;
    },

    updateFeedItem(state, payload) {
        payload.item.content = payload.content;
    },

    highlightFeedItem(state, payload) {
        payload.item.highlighted = true;
    },

    setTopicHelpdeskFilter(state, payload) {
        payload.topic.ticket_status = payload.status;
    },

    setHelpdeskFilter(state, payload) {
        state.helpdeskFilter = payload;
    },

    setMoodTopic(state, payload) {
        state.moodboardTopic = payload;
    },

    setMoodview(state, payload) {
        state.moodviewOpen = payload;
    },

    //function to add the user to the ActiveData users model
    addAuthenticatedUser(state) {
        let newUser = ActiveDataStore.activeDataCreateResource(window.User, 'users', {});

        newUser.active_trophy = user.active_trophy;
        newUser.id = user.id;
        newUser.name = user.first_name + ' ' + user.last_name;
        newUser.avatar = user.avatar;
        newUser.username = user.username;
        newUser.karma = user.karma;
        newUser.isAdmin = user.isAdmin;
        newUser.isModerator = user.isModerator;

        let user_data = {
            model: window.User,
            instance: newUser,
            plural: 'users'
        };

        this.commit('addActiveDataInstance', user_data);
    },

    // Add posts to variable
    setBlogPosts(state, payload) {
        state.blogPost = payload;
    },

    //Set active trophy
    setActiveTrophy(state, payload) {
        if (payload) {

            state.activeTrophy = payload[0];
            if (state.activeTrophy) {
                state.activeTrophy['image'] = payload[1];
            }
        } else {
            state.activeTrophy = null;
        }
    },

    setTrophies(state, payload) {
        state.trophies = payload;
    },

    setTrophiesProgress(state, payload) {
        state.trophiesProgress = payload;
    },

    introduceNewUser(state, payload) {
        state.isNewUser = payload;
    },

    newUserChecked(state) {
        state.checkedForNewUser = true;
    },

    increaseCommentTimeout(state) {
        state.comment_load_timeout += 50;
    },

    decreaseCommentTimeout(state) {
        state.comment_load_timeout -= 50;
    },

    increaseReplyTimeout(state) {
        state.reply_load_timeout += 50;
    },

    decreaseReplyTimeout(state) {
        state.reply_load_timeout -= 50;
    },

    setErrorMessage(state, payload) {
        state.errorMessage = payload;
    },

    showBottomError(state, payload) {
        state.showBottomError = payload;
    },

    toggleContentWithoutModuleVisibility(state) {
        state.display_content_without_module = !state.display_content_without_module;
    },

    // v2 editor active uuid
    setActiveEditorUUID(state, uuid) {
        state.active_editor_v2_uuid = uuid;
    },

    setBoardsLoaded(state) {
        state.boards_loaded = true;
    },

    setMoodboardsLoaded(state) {
        state.moodboards_loaded = true;
    },

    setScreenWidth(state, width) {
        state.screen_width = width;
    },
};

let actions = {
    submitNewTopic(context, data) {
        let post_data = data.data.data;
        let channel = data.data.channel;

        axios.post('/conversations/', post_data)
            .then(function (response) {
                if (response.data.status === 200) {
                    //add own user to the store if it wasn't there already
                    if (!state.users_ids.includes(user.id)) {
                        context.commit('addAuthenticatedUser');
                    }

                    //add the topic
                    let topic = ActiveDataStore.activeDataCreateResource(window.Topic, 'topics', response.data.instance_data);

                    //topic data
                    topic.created_at = response.data.instance_data.created_at;
                    topic.content = response.data.instance_data.content;
                    topic.excerpt = response.data.instance_data.excerpt;
                    topic.board_id = response.data.instance_data.board_id;
                    topic.board_name = response.data.instance_data.board_name;
                    topic.board_type = response.data.instance_data.board_type;
                    topic.post_id = response.data.comment.id;
                    topic.newly_created = true;
                    topic.avatar = response.data.instance_data.user.avatar;
                    topic.user_id = response.data.instance_data.user.id;
                    topic.ticket_status = 'open';
                    topic.comments_count = 1;

                    if (channel.name !== state.activeBoard.name) {
                        topic.master_board_name = state.activeBoard.name;
                    } else {
                        topic.master_board_name = channel.name;
                    }

                    // topic attachments
                    let uploads = [];

                    if (topic.post_type === 'image' || topic.post_type === 'poll') {
                        forEach(data.data.imagesPreviews, function (image_preview, index) {
                            uploads.push({
                                source: image_preview,
                                title: data.data.images[index].name,
                                filetype: data.data.images[index].type,
                            })
                        });
                    } else if (topic.post_type === 'text') {
                        forEach(data.data.attachments, function (attachment, index) {
                            uploads.push({
                                source: '#',
                                name: attachment.name,
                            })
                        });
                    }

                    if (uploads.length > 0) {
                        topic.attachments = uploads;
                    }

                    let topic_data = {
                        model: window.Topic,
                        instance: topic,
                        plural: 'topics'
                    };

                    context.commit('addActiveDataInstance', topic_data);
                    context.commit('clearNewPost');

                } else {
                    alert('Something went wrong. Please check whether all fields are filled in and if possible attachments do not exceed the size limit of 8MB.');
                }

                context.commit('toggleSpinner', false);
            })
            .catch(error => {
                alert('Something went wrong. Please check whether all fields are filled in and if possible attachments do not exceed the size limit of 8MB.');
                context.commit('toggleSpinner', false);
            });
    },

    submitNewMoodpost(context, data) {
        return new Promise((resolve, reject) => {
            let post_data = data.data.data;

            axios.post('/conversations/', post_data)
                .then(function (response) {
                    if (response.data.status === 200) {
                        resolve(true);

                        //add own user to the store if it wasn't there already
                        if (!state.users_ids.includes(user.id)) {
                            context.commit('addAuthenticatedUser');
                        }

                        //add the topic
                        let topic = ActiveDataStore.activeDataCreateResource(window.Topic, 'topics', response.data.instance_data);

                        //topic data
                        topic.created_at = response.data.instance_data.created_at;
                        topic.content = post_data.content;
                        topic.excerpt = post_data.content;
                        topic.board_id = boardId;
                        topic.post_id = response.data.comment.id;
                        topic.newly_created = true;
                        topic.comments_count = 1;

                        let uploads = [];

                        uploads.push({
                            source: post_data.new_post_image_preview,
                            title: post_data.new_post_image_file.name,
                            type: 'image',
                        });

                        topic.attachments = uploads;

                        let topic_data = {
                            model: window.Topic,
                            instance: topic,
                            plural: 'topics'
                        };

                        context.commit('addActiveDataInstance', topic_data);
                    } else {
                        reject();
                    }

                    context.commit('toggleSpinner', false);
                })
                .catch(error => {
                    reject();
                    context.commit('toggleSpinner', false);
                });
        });
    },

    submitComment(context, data) {
        let payload = data.data.payload;
        let post_data = data.data.data;

        axios.post(`/api/v3/topics/${data.data.id}/comments`, post_data)
            .then(function (response) {
                let comment = ActiveDataStore.activeDataCreateResource(window.Comment, 'comments', response.data.data);
                let user = ActiveDataStore.activeDataCreateResource(window.User, 'users', response.data.data.user);
                let uploads = [];

                forEach(payload.imagesPreview, function (image_preview, index) {
                    uploads.push({
                        source: image_preview,
                        title: payload.images[index].name,
                        type: payload.images[index].type,
                        filetype: payload.images[index].type,
                    })
                });

                if (uploads.length > 0) {
                    comment.attachments = uploads;
                }

                let comment_data = {
                    model: window.Comment,
                    instance: comment,
                    plural: 'comments'
                };

                let user_data = {
                    model: window.User,
                    instance: user,
                    plural: 'users'
                };

                context.commit('addActiveDataInstance', comment_data);
                context.commit('addActiveDataInstance', user_data);
                context.commit('postCommentsCount', [payload.custom_data.topic, 'increment']);
                data.data.success_callback();

                context.commit('toggleSpinner', false);
            })
            .catch(error => {
                alert('Something went wrong. Please check whether all fields are filled in and if possible attachments do not exceed the size limit of 8MB.');
                context.commit('toggleSpinner', false);
            });
    },

    submitReply(context, data) {
        let payload = data.data.payload;
        let post_data = data.data.data;

        axios.post(`/api/v3/topics/${data.data.id}/comments`, post_data)
            .then(function (response) {
                let reply = ActiveDataStore.activeDataCreateResource(window.Reply, 'replies', response.data.data);
                let user = ActiveDataStore.activeDataCreateResource(window.User, 'users', response.data.data.user);

                let reply_data = {
                    model: window.Reply,
                    instance: reply,
                    plural: 'replies'
                };

                let user_data = {
                    model: window.User,
                    instance: user,
                    plural: 'users'
                };

                context.commit('addActiveDataInstance', reply_data);
                context.commit('addActiveDataInstance', user_data);
                context.commit('postCommentsCount', [payload.custom_data.topic, 'increment']);

                context.commit('toggleSpinner', false);
            })
            .catch(error => {
                alert('Something went wrong, please try posting again later. If this issue persists, please contact an administrator.');
                context.commit('toggleSpinner', false);
            });
    },

    // Get blog posts
    getBlogPosts({ commit }, payload) {
        // var user_id = payload;
        return axios.get('/blog-feed')
            .then(function (response) {
                commit('setBlogPosts', response.data);
            }).catch((response) => {
            })
    },
    // Achievements / Trophies
    getAchievements({ commit }, user_id) {
        // also send user_id as param to get prgoress of other users achievements to display on profile
        return axios.get(`/api/v3/users/${user_id}/gamification`, { params: { user_id } })
            .then(function (response) {
                //set trophies in store
                commit('setTrophies', response.data.data.achievements);

                //check if a trophy is active
                let active_trophy = response.data.find(achievement => achievement.active === true);

                if (!active_trophy) {
                    active_trophy = {
                        id: 0,
                        background: 'e2e2e2',
                        borderw: 'd2d2d2',
                        color: '757575',
                        icon: 'fa fa-trophy',
                        title: 'Be a winner',
                        desc: 'Selecteer een behaalde trophy om die bij je profiel te tonen'
                    };
                }

                commit('setActiveTrophy', [active_trophy, false]);
            }).catch((response) => {
            })
    },

    storeActiveTrophy(context, data) {
        let trophy_id = data.id;

        axios.post('/achievements/activate/' + trophy_id)
            .then(function (response) {

                if (response.status == 200) {
                    if (response.data.length !== 0) {
                        context.commit('setActiveTrophy', [data, data['image']]);
                    } else {
                        context.commit('setActiveTrophy', [false, false]);
                    }
                }

                context.commit('toggleSpinner', false);
            });

    },


    search(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get('/api/v3/search', payload.request)
                .then((response) => {
                    context.commit('setSearchResults', {
                        results: response.data.results,
                        search_more: payload.search_more
                    });
                    resolve(true);
                }, error => {
                    reject(error);
                });
        });
    },

    storePoll(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/v3/quiz-maker/quizzes/', payload).then((poll) => {

                let data = {};
                data.settings = [];

                Object.keys(payload.settings).map(function (key, index) {
                    data.settings.push({
                        'setting': key,
                        'value': payload.settings[key]
                    })
                });

                axios.post('/api/v3/quiz-maker/quizzes/' + poll.data.data.id + '/settings', data).then(() => {
                    resolve(poll.data.data);
                });
            });
        });
    },

    storePollQuestion(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/v3/quiz-maker/questions/', payload.question).then(function (response) {

                axios.post('/api/v3/quiz-maker/quizzes/' + payload.poll_id + '/questions', { questions: [response.data.data.id] })
                    .then(() => {

                    });

                resolve(response.data.data);
            });
        });
    },

    storePollQuestionOptions(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('/api/v3/quiz-maker/questions/' + payload.id + '/options', { question_options: payload.question_options })
                .then((response) => {
                    resolve(response.data.data[0]);
                });
        });
    },

    storeImage(context, payload) {
        let form_data = new FormData();

        for (var key in payload) {
            if (key === 'file') {
                form_data.append('files[]', payload.file, payload.file.name);
            } else {
                form_data.append(key, payload[key]);
            }
        }

        return new Promise((resolve, reject) => {
            axios.post('/uploader', form_data).then(() => {
                resolve(true);
            }).catch(() => {
                reject();
            });
        });
    },

    removeImage(context, file_id) {
        return new Promise((resolve, reject) => {
            axios.delete('/uploader/' + file_id + '/delete').then(() => {
                resolve(true);
            });
        });
    },

    getCoursesForAuthor(context, id) {
        let url = '/api/v3/courses?where=author_id:' + id;

        return new Promise((resolve, reject) => {
            axios.get(url).then((response) => {
                resolve(response);
            })
        });
    },

    saveNewOrder(context, payload) {
        return new Promise((resolve) => {
            const order = {
                type: payload.model,
                items: [],
            };

            if (payload.parent_id !== false) {
                order.parent_id = payload.parent_id;
            }

            for (let i = 0; i < payload.items.length; i += 1) {
                order.items.push(
                    {
                        id: payload.items[i].id,
                        index: payload.items[i].index,
                    },
                );
            }

            axios.put('/api/v3/multi-ordering', order).then(() => {
                resolve(true);
            });
        });
    },
};

getters = ActiveDataStore.mergeStoreProperties(getters, 'getters');
mutations = ActiveDataStore.mergeStoreProperties(mutations, 'mutations');
actions = ActiveDataStore.mergeStoreProperties(actions, 'actions');

export default new Vuex.Store({
    plugins: [VuexORM.install(database, { namespace: 'db' })],
    modules: {
        cookiepopup,
        quiz,
        poll,
        modal,
    },
    state,
    mutations,
    actions,
    getters
});
